var React = require('react');

function CheckboxUncheckedInline (props) {
    return React.createElement("svg",props,React.createElement("rect",{"x":"1","y":"1","width":"21","height":"21","rx":"5","strokeWidth":"2"}));
}

CheckboxUncheckedInline.defaultProps = {"width":"23","height":"23","viewBox":"0 0 23 23","fill":"none"};

module.exports = CheckboxUncheckedInline;

CheckboxUncheckedInline.default = CheckboxUncheckedInline;
